import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getOwnerToken } from './ownerBaseApi';

const BASE_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:4000/api/v2';
const BIDDER_TOKEN_KEY = 'imperium_bidder_token';

export function getBidderToken(): string | null {
  try { return localStorage.getItem(BIDDER_TOKEN_KEY); } catch { return null; }
}
export function setBidderToken(token: string) {
  try { localStorage.setItem(BIDDER_TOKEN_KEY, token); } catch { /* ignore */ }
}
export function clearBidderToken() {
  try { localStorage.removeItem(BIDDER_TOKEN_KEY); } catch { /* ignore */ }
}

/**
 * Devuelve el token disponible: preferencia bidder, fallback owner.
 * El backend (authenticateBidder) acepta ambos scopes.
 */
export function getAuctionAuthToken(): string | null {
  return getBidderToken() ?? getOwnerToken();
}

/**
 * API para postores — token JWT con scope auction_bidder u owner_portal.
 */
export const bidderBaseApi = createApi({
  reducerPath: 'bidderApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      const token = getAuctionAuthToken();
      if (token) headers.set('Authorization', `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ['Auction'],
  endpoints: () => ({}),
});
